/**
 * Created by Mark on 18/04/2017.
 */

import ClassServices from '../../services/classes-service.js';
import ClassStore from '../../store/classes-store.js';
import React from 'react';
import { FormattedMessage } from 'react-intl';
import Select from  'react-select';

export default class LanguageSelector extends React.Component {

    constructor(props){
        super();
        this.props = props;
        this.state = {names:[] , value :null}
        this.onSelect = this.onSelect.bind(this);
    }

    componentDidMount() {
        ClassServices.getViewableClassesNameList()
    }

    componentWillReceiveProps(nextProps){
        this.setState({value:nextProps.value});
    }

    componentWillMount(){

        ClassStore.on("UPDATE_NAMES_CLASSES_LIST" , () => {
            this.setState({names:ClassStore.names, value:this.state.value});
        });
    }

    onSelect(value){
        if(this.props.onSelect) this.props.onSelect(value);
        this.setState({value:value});
    }

    render(){

        console.log(this.state.names);

        const options = this.state.names.map(function(names){
             return  { value: names.uid, label: names.name}
        });

        return <Select multi={this.props.multi} onChange={this.onSelect} className={this.props.className} value={this.state.value} 
                options={options} noResultsText={<FormattedMessage id={ "ui-2011"} defaultMessage={ "No Results Found" }/>}
                placeholder={<FormattedMessage id={ 'ui-892' } defaultMessage={ 'Select' }/>}/>
    }

}



// WEBPACK FOOTER //
// ./src/components/inputs/classes-selector.js